import { isEmergencyMode } from '../emergency';
import { getNoticeEndAt, shouldShowNotice, dismissNotice } from '../utils/noticeVisibility';
import { getCookie } from "../utils/cookie";
import { updateToolkitInfo } from "./upsertToolkitInfo";

const toolUpdateNotices = {
  board: { id: 'board-update-20260914', startAt: '2026-09-14T00:00:00+09:00' },
  seatswapper: { id: 'seatswapper-update-20260908', startAt: '2026-09-08T00:00:00+09:00' },
  note: { id: 'note-update-20260908', startAt: '2026-09-08T00:00:00+09:00' },
};
const dismissedToolUpdates = new Set();

const UpdateManager = {
  watchToolUpdateNotices() {
    if (this.toolNoticeWatcherStarted) return;
    this.toolNoticeWatcherStarted = true;
    const refresh = () => {
      clearTimeout(this.toolNoticeTimer);
      this.updateUI();
      const now = Date.now();
      const nextBoundary = Object.values(toolUpdateNotices)
        .flatMap(notice => [new Date(notice.startAt).getTime(), getNoticeEndAt(notice).getTime()])
        .filter(time => time > now);
      if (nextBoundary.length) {
        this.toolNoticeTimer = setTimeout(refresh, Math.min(Math.min(...nextBoundary) - now, 86400000));
      }
    };
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('storage', refresh);
    refresh();
  },
  // 업데이트 상태 초기화 및 로컬 스토리지에 저장하는 함수
  saveInitialMenuStatus() {
    const menuStatusString = localStorage.getItem('menuStatus');
    if (!menuStatusString) {
      const initialMenuStatus = {
        stopwatch: false,
        timer: false,
        dice: false,
        coin: false,
        random: false,
        wheel: false,
        memo: false,
        whistler: false,
        noisemonitor: false,
        qrcode: false,
        clock: false,
        crayon: false,
        board: false,
        classthermo: false,
        tooladd: false,
        background: false,
        setting: false,
        toolbarPosition: false,
        toolbarAutoHide: false,
        toolLayerAutoHide: false,
        usernameHide: false,
        newWindow: false,
        tonlyAll: false,
        randomPresetOrder: false,
        topPin: false,
        video: false,
        scoreboard: false,
        toolbarStyle: false,
        switchToolbarStyle: false,
        nationalrite: false,
        seatswapperPresetOrder: false,
        seatswapper: false,
        digitaledutool: false,
        staticBg: false,
        checklist: false,
        air: false,
        marble: false,
        classes: false,
        classTooltip: false,
        tournament: false,
        dday: false,
        note: false,
        classduty: false,
        // 추가 메뉴가 있다면 여기에 추가
      };
      localStorage.setItem('menuStatus', JSON.stringify(initialMenuStatus));
    }
  },

  // 업데이트 체크 함수
  checkUpdates() {
    // console.log(localStorage.getItem('toolOrder'))
    const updateDate = new Date('2026-08-03T00:00:00+09:00'); //예시: 2024년 11월 15일 한국 시간 오전 8시(2024-11-15T08:00:00+09:00)(수정할 부분)
    //업데이트 정보를 기입(업데이트를 표시하려는 메뉴를 true로 표기) 
    //신규 수업도구일 경우 updateInfo와 하단에 newToolInfo에도 추가해서 true 표시 해줘야 함(중요)
    const updateInfo = {
      note: true,
      classduty: true,
    }
    const menuStatus = this.getMenuStatus();
    // console.log(localStorage.getItem('updateDate'))
    let updateDateMenu;
    updateDateMenu = new Date(this.convertToISO8601(localStorage.getItem('updateDate')));
    // 현재 날짜를 가져옴
    const currentDate = new Date();
    // 신규 도구 N 표시 기본 정책: 시작일로부터 달력 기준 2개월
    const newToolEndDate = new Date(updateDate);
    newToolEndDate.setMonth(newToolEndDate.getMonth() + 2);
    // 현재 날짜가 업데이트 날짜 이후이면서 신규 도구 노출 종료일 전이라면 표시
    // console.log('currentDate', currentDate, 'newToolEndDate', newToolEndDate);
    if(currentDate >= updateDate && currentDate < newToolEndDate) {
      // console.log('시간이 안 지났음', 'updateDateMenu', updateDateMenu)
      if(!updateDateMenu){ //updateDateMenu 데이타가 기록된 적이 없는 경우 새로 업데이트 표시
        for (const menuId in updateInfo) {
          if (updateInfo.hasOwnProperty(menuId)) {
            const hasUpdate = updateInfo[menuId];
            const currentStatus = menuStatus[menuId];
            // console.log('hasUpdate', hasUpdate, 'currentStatus', currentStatus)
            // marble 메뉴 예외 처리: 2025년 3월 7일까지 "New" 유지
            if(hasUpdate && !currentStatus) {
              // 업데이트가 있는 메뉴의 업데이트 상태를 변경
              if(menuId == 'background'){
                if(getCookie('mId') !== "" && getCookie('mId') !== undefined){ //로그인 상태인경우
                  this.setMenuUpdateStatus(menuId, true);
                }else{
                  this.setMenuUpdateStatus(menuId, false);
                }
              }else{
                this.setMenuUpdateStatus(menuId, true);
              }
            }else{
              if(menuId == 'background'){
                if(getCookie('mId') == "" || getCookie('mId') == undefined){ //로그인 상태인경우
                  this.setMenuUpdateStatus(menuId, false);
                }
              }
            }
          }
        }
      }else{ //updateDateMenu 데이타가 있는 경우
        //로컬스토리지에 기록된 업데이트 날짜가 코드상의 업데이트 날짜보다 같거나 이전일 경우메만 새로 업데이트 표시
        // console.log(updateDateMenu, updateDate, updateDateMenu <= updateDate)
        if(updateDateMenu.getTime() <= updateDate.getTime()){
          for (const menuId in updateInfo) {
            if (updateInfo.hasOwnProperty(menuId)) {
              const hasUpdate = updateInfo[menuId];
              const currentStatus = menuStatus[menuId];
              if(hasUpdate && !currentStatus) {
                // 업데이트가 있는 메뉴의 업데이트 상태를 변경
                if(menuId == 'background'){
                  if(getCookie('mId') !== "" && getCookie('mId') !== undefined){ //로그인 상태인경우
                    this.setMenuUpdateStatus(menuId, true);
                  }
                }else{
                  this.setMenuUpdateStatus(menuId, true);
                }
              }else{
                if(menuId == 'background'){
                  if(getCookie('mId') == "" || getCookie('mId') == undefined){ //로그인 상태인경우
                    this.setMenuUpdateStatus(menuId, false);
                  }
                }
              }
            }
          }
        }
      }
    }else{
      // console.log('시간이 지났음')
      for (const menuId in menuStatus) {
        this.setMenuUpdateStatus(menuId, false);
      }
    }
    this.updateUI();
    this.watchToolUpdateNotices();
  },

  // 특정 메뉴의 업데이트 상태 변경 함수
  setMenuUpdateStatus(menuId, hasUpdate) {
    const menuStatus = this.getMenuStatus();

    menuStatus[menuId] = hasUpdate;
    localStorage.setItem('menuStatus', JSON.stringify(menuStatus));
  },

  // 특정 메뉴의 업데이트 상태 가져오는 함수
  getMenuUpdateStatus(menuId) {
    if (isEmergencyMode) return false;
    if (Object.prototype.hasOwnProperty.call(toolUpdateNotices, menuId)) {
      return !dismissedToolUpdates.has(menuId) && shouldShowNotice(toolUpdateNotices[menuId]);
    }
    const menuStatus = this.getMenuStatus();
    return menuStatus[menuId];
  },

  // 메뉴 상태 가져오는 함수
  getMenuStatus() {
    const menuStatusString = localStorage.getItem('menuStatus');

    if (menuStatusString) {
      return JSON.parse(menuStatusString);
    }

    // 로컬 스토리지에 메뉴 상태가 없는 경우 초기화
    // this.saveInitialMenuStatus();
    return JSON.parse(localStorage.getItem('menuStatus'));
  },

  // UI 업데이트 함수
  updateUI() {
    if (isEmergencyMode) return;
    const menuElements = document.querySelectorAll('[data-name]');
    // console.log("menuElements", menuElements)
    //새로운 수업도구가 추가되었을 경우 수정(230809) - new 표시하기
    const newToolInfo = {
      note: true,
      classduty: true,
    }

    const toolOrder = localStorage.getItem('toolOrder');
    // console.log('toolOrder', toolOrder)
    menuElements.forEach(menuElement => {
      const menuId = menuElement.dataset.name;
      const hasUpdate = this.getMenuUpdateStatus(menuId);
      if (Object.prototype.hasOwnProperty.call(toolUpdateNotices, menuId)) {
        menuElement.classList.remove('new');
      }
      // console.log(menuId, hasUpdate);
      if (hasUpdate) {
        if(menuId == 'setting'){
          if(getCookie('mId') == "" || getCookie('mId') == undefined){ //로그아웃 상태인경우
            //로그인상태외에도 항상 보여주는 옵션메뉴가 true 상태인 경우(업데이트 표시되어야 하는경우)
            if(this.getMenuUpdateStatus('toolbarPosition') == true || 
               this.getMenuUpdateStatus('toolbarAutoHide') == true || 
               this.getMenuUpdateStatus('toolLayerAutoHide') == true ||
               this.getMenuUpdateStatus('toolbarStyle') == true || 
               this.getMenuUpdateStatus('background') == true){
                menuElement.classList.add('update'); //setting에 업데이트 표시
            }else{ //그렇지 않은 경우
              menuElement.classList.remove('update'); //setting에 업데으트 표시 삭제
            }
          }else{
            menuElement.classList.add('update');
          }
        }else{
          menuElement.classList.add('update');
          //일치하는 툴이 있을 경우 new 표시
          // console.log('menuId', menuId)
          if(newToolInfo.hasOwnProperty(menuId) && !Object.prototype.hasOwnProperty.call(toolUpdateNotices, menuId)){
            menuElement.classList.add('new');
            // toolOrder.push(menuId);
            // localStorage.setItem('toolOrder', toolOrder);
          }
        }
      } else {
        if(menuId == 'setting'){
          if(getCookie('mId') == "" || getCookie('mId') == undefined){ //로그아웃 상태인경우
            menuElement.classList.remove('update');
          }else{
            if(this.getMenuUpdateStatus('usernameHide')){
              menuElement.classList.add('update');
            }else{
              menuElement.classList.remove('update');
            }
          }
        }else{
          menuElement.classList.remove('update');
          // 클래스 한번 클릭시 클래스 툴팁 변경 표시
          if(menuId == 'classes'){
            menuElement.querySelector('.tooltip').textContent = '클래스';
            menuElement.querySelector('.tooltip').classList.add('clicked');
          }
        }
      }
    });

    // 업데이트 클래스 툴팁 표시 여부 설정
    const classTooltip = document.querySelector(".system-tool-wrapper .btn-classes .tooltip");
    const deadline = new Date("2025-03-14T23:59:59"); // 사용자의 로컬 시간 기준
    const now = new Date();
    // const now = new Date("2025-03-15T00:00:00"); //테스트용

    if (now > deadline) {
        classTooltip.classList.add('hide'); // 3월 15일부터 숨김
    } else {
        classTooltip.classList.remove('hide'); // 3월 14일까지 표시
    }

    //뽑기 레이스 new 표시 여부 설정
    // const marbleNew = document.querySelector(`.tool-wrapper[data-name="marble"]`);
    // const marbleDeadline = new Date("2025-03-20"); // 사용자의 로컬 시간 기준
    // const marbleNow = new Date();
    // // const marbleNow = new Date("2025-03-21"); //테스트용
    
    // if (marbleNow > marbleDeadline) {
    //   marbleNew.classList.remove('new', 'update'); // 3월 8일부터 숨김
    //   this.setMenuUpdateStatus('marble', false);
    // } else {
    //   marbleNew.classList.add('new'); // 3월 7일까지 표시
    // }
  },

  // 메뉴 클릭 이벤트 핸들러
  handleMenuClick(menuId) {
    if (Object.prototype.hasOwnProperty.call(toolUpdateNotices, menuId)) {
      dismissNotice(toolUpdateNotices[menuId]);
      if (shouldShowNotice(toolUpdateNotices[menuId])) dismissedToolUpdates.add(menuId);
      this.setMenuUpdateStatus(menuId, false);
      this.updateUI();
      updateToolkitInfo();
      return;
    }
    // console.log('handleMenuClick', menuId);

    const marbleDateLimit = new Date('2025-03-20'); // 2025년 3월 20일로 날짜 제한 설정
    // 현재 날짜가 제한 날짜 이전이라면 "new" 표시가 계속 유지되도록
    if (new Date() <= marbleDateLimit) {
        // 만약 menuId가 'marble'이면 업데이트를 방지하여 "new" 표시가 사라지지 않게 함
        if (menuId === 'marble') {
            return;  // 해당 메뉴 클릭 시 아무 동작도 하지 않도록 함
        }
    }

    // 업데이트 상태 변경
    if(menuId == 'background'){
      if(getCookie('mId') !== "" && getCookie('mId') !== undefined){ //로그인 상태인경우
        this.setMenuUpdateStatus(menuId, false);
      }
    }else{
      this.setMenuUpdateStatus(menuId, false);
    }
    

    this.setData('updateDate', new Date()); //업데이트메뉴를 한번이라도 클릭했으면 날짜 저장(업데이트 메뉴표시에 활용)
    updateToolkitInfo(); //api 변경
    // 해당 메뉴 엘리먼트 선택
    let menuElement;
    if(menuId == 'toolbarPosition' || menuId == 'toolbarAutoHide' || menuId == 'toolLayerAutoHide' || menuId == 'usernameHide' ||
       menuId == 'tonlyAll' || menuId == 'randomPresetOrder' || menuId == 'seatswapperPresetOrder'){
      menuElement = document.querySelector(`.manage-toolbar-container .toggle-pill-color[data-name="${menuId}"]`);
    }else if(menuId == 'toolbarStyle'){
      menuElement = document.querySelector(`.manage-toolbar-container .title[data-name="${menuId}"]`);
    }else if(menuId == 'toolbarTooltip'){
      menuElement = document.querySelector(`.footer-container .toolbar-tooltip`);
    }else if(menuId == 'switchToolbarStyle'){
      menuElement = document.querySelector(`.footer-container .btn-toolbar-style`);
    }else if(menuId == 'staticBg'){
      menuElement = document.querySelector(`.manage-background-container .toggle-pill-color[data-name="${menuId}"]`);
    }else if(menuId == 'classTooltip'){
      menuElement = document.querySelector(`.manage-class-container .top-header .class-tooltip`);
    }else{
      menuElement = document.querySelector(`.footer-container .tool-wrapper[data-name="${menuId}"]`);
    }
    console.log(menuElement);
    // 업데이트 상태에 따라 UI 업데이트
    const hasUpdate = this.getMenuUpdateStatus(menuId);
    console.log('hasUpdate', hasUpdate);

    if (hasUpdate) {
      menuElement.classList.add('update');
    } else {
      menuElement.classList.remove('update');
      if(menuId == 'classes'){
        menuElement.querySelector('.tooltip').textContent = '클래스';
        menuElement.querySelector('.tooltip').classList.add('clicked');
      }
    }
  },

  setData(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  
  getData(key) {
    const value1 = localStorage.getItem(key);
    // console.log(key, typeof(value1));
    let value = JSON.parse(localStorage.getItem(key));
    
    return value;
  },

  convertToISO8601(inputDateString) {
    // console.log('inputDateString',inputDateString)
    const iso8601Pattern = /^"\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z"$/;
    // console.log(iso8601Pattern.test(inputDateString));
    if (!iso8601Pattern.test(inputDateString)) {
      const inputDate = new Date(inputDateString);
  
      // Date 객체를 ISO 8601 형식의 문자열로 변환합니다.
      const iso8601Date = inputDate.toISOString();
      // console.log('iso8601Date', iso8601Date)
      return iso8601Date;
    }
    
    // console.log('inputDateString', inputDateString)
    return inputDateString.replace(/^"|"$/g, ''); // 이미 ISO 8601 형식이라면 그대로 반환(좌우 " 삭제)
  }
};

export default UpdateManager;
